import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { reload } = useAuth();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const token = params.get("token");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    let done = false;
    api.post("/auth/verify-email", { token })
      .then(() => { if (!done) { setStatus("success"); reload?.(); } })
      .catch(() => { if (!done) setStatus("error"); });
    return () => { done = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div data-testid="verify-email-page" className="max-w-[560px] mx-auto px-6 py-24 text-center">
      {status === "loading" && (
        <div data-testid="verify-loading">
          <Loader2 size={40} className="mx-auto animate-spin text-neutral-400" />
          <p className="mt-6 label-eyebrow">Confirming your email…</p>
        </div>
      )}
      {status === "success" && (
        <div data-testid="verify-success">
          <CheckCircle2 size={44} className="mx-auto" style={{ color: "#1E7A3B" }} />
          <h1 className="font-display text-4xl tracking-tighter mt-5">Email verified.</h1>
          <p className="mt-4 text-neutral-500">Thank you — your email address is confirmed. Your account is all set.</p>
          <div className="mt-8 flex gap-3 justify-center">
            <Link to="/" className="btn-primary" data-testid="verify-home-btn">Back home</Link>
            <Link to="/browse" className="btn-outline" data-testid="verify-browse-btn">Start browsing</Link>
          </div>
        </div>
      )}
      {status === "error" && (
        <div data-testid="verify-error">
          <XCircle size={44} className="mx-auto text-red-500" />
          <h1 className="font-display text-4xl tracking-tighter mt-5">Link expired or invalid.</h1>
          <p className="mt-4 text-neutral-500">
            This verification link is invalid or has already been used. If you already verified, you're good to go.
            Otherwise, sign in and use the “Resend verification email” option.
          </p>
          <div className="mt-8 flex gap-3 justify-center">
            <Link to="/auth" className="btn-primary" data-testid="verify-signin-btn">Sign in</Link>
            <Link to="/" className="btn-outline">Back home</Link>
          </div>
        </div>
      )}
    </div>
  );
}
